/**@jsx jsx */
import { jsx } from 'theme-ui';

export const Download = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7486 15.2146C14.7486 15.6052 14.4249 15.9289 14.0343 15.9289C13.6437 15.9289 13.32 15.6052 13.32 15.2146C13.32 14.8239 13.6437 14.5003 14.0343 14.5003C14.4249 14.5003 14.7486 14.8239 14.7486 15.2146ZM17.6057 15.2146C17.6057 15.6052 17.2821 15.9289 16.8915 15.9289C16.5008 15.9289 16.1772 15.6052 16.1772 15.2146C16.1772 14.8239 16.5008 14.5003 16.8915 14.5003C17.2821 14.5003 17.6057 14.8239 17.6057 15.2146ZM19.0343 12.7146C19.0343 12.123 18.5544 11.6431 17.9629 11.6431H12.7843L11.2665 13.161C10.8535 13.5628 10.3178 13.786 9.74861 13.786C9.17941 13.786 8.64369 13.5628 8.23075 13.161L6.72405 11.6431H1.53432C0.942801 11.6431 0.462891 12.123 0.462891 12.7146V16.286C0.462891 16.8775 0.942801 17.3574 1.53432 17.3574H17.9629C18.5544 17.3574 19.0343 16.8775 19.0343 16.286V12.7146ZM15.4071 6.36412C15.2955 6.10742 15.0388 5.92885 14.7486 5.92885H11.8915V0.92885C11.8915 0.538225 11.5678 0.214563 11.1772 0.214563H8.32003C7.92941 0.214563 7.60575 0.538225 7.60575 0.92885V5.92885H4.74861C4.45843 5.92885 4.20173 6.10742 4.09012 6.36412C3.97852 6.63197 4.03432 6.94447 4.24637 7.14537L9.24637 12.1454C9.3803 12.2905 9.57003 12.3574 9.74861 12.3574C9.92718 12.3574 10.1169 12.2905 10.2508 12.1454L15.2508 7.14537C15.4629 6.94447 15.5187 6.63197 15.4071 6.36412Z"
      fill="#FDFFFF"
    />
  </svg>
);

export const Mail = ({ className }) => (
  <svg
    className={className}
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 5.13867C19.9152 5.50697 19.5357 5.83064 19.1339 6.10965C17.2701 7.37081 15.3951 8.64314 13.5759 9.9601C12.6384 10.6521 11.4777 11.5003 10.2612 11.5003H10.25H10.2388C9.02232 11.5003 7.86161 10.6521 6.92411 9.9601C5.10491 8.63197 3.22991 7.37081 1.37723 6.10965C0.964286 5.83064 0.584821 5.50697 0.25 5.13867V14.0003C0.25 14.9824 1.05357 15.786 2.03571 15.786H18.4643C19.4464 15.786 20.25 14.9824 20.25 14.0003V5.13867ZM20.25 1.85742C20.25 0.875278 19.4353 0.0717072 18.4643 0.0717072H2.03571C0.841518 0.0717072 0.25 1.00921 0.25 2.10296C0.25 3.11858 1.37723 4.37974 2.16964 4.91546C3.89955 6.12081 5.65179 7.32617 7.3817 8.54269C8.10714 9.04492 9.33482 10.0717 10.2388 10.0717H10.25H10.2612C11.1652 10.0717 12.3929 9.04492 13.1183 8.54269C14.8482 7.32617 16.6004 6.12081 18.3415 4.91546C19.3237 4.23465 20.25 3.10742 20.25 1.85742Z"
      fill="#FDFFFF"
    />
  </svg>
);

export const Instagram = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6044 9.21456C11.6044 10.7882 10.3209 12.0717 8.74721 12.0717C7.17355 12.0717 5.89007 10.7882 5.89007 9.21456C5.89007 7.6409 7.17355 6.35742 8.74721 6.35742C10.3209 6.35742 11.6044 7.6409 11.6044 9.21456ZM13.1445 9.21456C13.1445 6.78153 11.1802 4.81724 8.74721 4.81724C6.31417 4.81724 4.34989 6.78153 4.34989 9.21456C4.34989 11.6476 6.31417 13.6119 8.74721 13.6119C11.1802 13.6119 13.1445 11.6476 13.1445 9.21456ZM14.3499 4.63867C14.3499 4.06947 13.8923 3.61189 13.3231 3.61189C12.7539 3.61189 12.2963 4.06947 12.2963 4.63867C12.2963 5.20787 12.7539 5.66546 13.3231 5.66546C13.8923 5.66546 14.3499 5.20787 14.3499 4.63867ZM8.74721 2.18331C9.99721 2.18331 12.6758 2.08287 13.803 2.5293C14.1936 2.68555 14.4838 2.87528 14.7852 3.17662C15.0865 3.47796 15.2762 3.76814 15.4325 4.15876C15.8789 5.28599 15.7785 7.96456 15.7785 9.21456C15.7785 10.4646 15.8789 13.1431 15.4325 14.2704C15.2762 14.661 15.0865 14.9512 14.7852 15.2525C14.4838 15.5539 14.1936 15.7436 13.803 15.8998C12.6758 16.3463 9.99721 16.2458 8.74721 16.2458C7.49721 16.2458 4.81864 16.3463 3.69141 15.8998C3.30078 15.7436 3.0106 15.5539 2.70926 15.2525C2.40792 14.9512 2.21819 14.661 2.06194 14.2704C1.61551 13.1431 1.71596 10.4646 1.71596 9.21456C1.71596 7.96456 1.61551 5.28599 2.06194 4.15876C2.21819 3.76814 2.40792 3.47796 2.70926 3.17662C3.0106 2.87528 3.30078 2.68555 3.69141 2.5293C4.81864 2.08287 7.49721 2.18331 8.74721 2.18331ZM17.3186 9.21456C17.3186 8.03153 17.3298 6.85965 17.2628 5.67662C17.1959 4.30385 16.8834 3.08733 15.8789 2.08287C14.8744 1.0784 13.6579 0.765903 12.2852 0.69894C11.1021 0.631975 9.93025 0.643135 8.74721 0.643135C7.56417 0.643135 6.3923 0.631975 5.20926 0.69894C3.8365 0.765903 2.61998 1.0784 1.61551 2.08287C0.611049 3.08733 0.298549 4.30385 0.231585 5.67662C0.164621 6.85965 0.175781 8.03153 0.175781 9.21456C0.175781 10.3976 0.164621 11.5695 0.231585 12.7525C0.298549 14.1253 0.611049 15.3418 1.61551 16.3463C2.61998 17.3507 3.8365 17.6632 5.20926 17.7302C6.3923 17.7972 7.56417 17.786 8.74721 17.786C9.93025 17.786 11.1021 17.7972 12.2852 17.7302C13.6579 17.6632 14.8744 17.3507 15.8789 16.3463C16.8834 15.3418 17.1959 14.1253 17.2628 12.7525C17.3298 11.5695 17.3186 10.3976 17.3186 9.21456Z"
      fill="#FDFFFF"
    />
  </svg>
);

export const Facebook = ({ className }) => (
  <svg
    className={className}
    width="11"
    height="19"
    viewBox="0 0 11 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2402 0.348493C9.9389 0.30385 8.90095 0.214563 7.69559 0.214563C5.17327 0.214563 3.44336 1.75474 3.44336 4.5784V7.01144H0.597377V10.315H3.44336V18.786H6.85854V10.315H9.69336L10.1286 7.01144H6.85854V4.90206C6.85854 3.9534 7.11523 3.29492 8.488 3.29492H10.2402V0.348493Z"
      fill="#FDFFFF"
    />
  </svg>
);

export const GitHub = ({ className }) => (
  <svg
    className={className}
    role="img"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>GitHub icon</title>
    <path
      d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
      fill="#FDFFFF"
    />
  </svg>
);
